'use client'

import Cookies from 'js-cookie'
import Image from 'next/image'
import { useEffect, useRef } from 'react'
import Link from 'next/link'
import styles from './NewsLetter.module.css'

export default function NewsLetter({ show = true, data }) {
  const modalElement = useRef()
  if (data.length === 0) return
  const newsLetter = data[0]

  useEffect(() => {
    // 紀錄彈出式廣告 一天只顯示一次
    const today = new Date().toDateString()
    Cookies.set('homePopupAdLastShown', today, { expires: 1 })

    const bootstrap = require('bootstrap')
    var myModal = new bootstrap.Modal(
      document.getElementById('newsletterPopup'),
      {
        keyboard: false,
      }
    )

    if (show) {
      myModal.show()
    }
    modalElement.current.addEventListener('hidden.bs.modal', () => {
      myModal.hide()
    })
  }, [])

  const resolveHref = (node) => {
    if (!node?.IsInternalURL) {
      return node?.ExternalURL?.trim() || '#'
    }

    if (!node?.LinkURL) return '#'

    const link = node.LinkURL.trim()
    const para = node.LinkURLPagePara?.trim() ?? ''

    // 首頁
    if (link === '/') return '/'

    // 判斷是否為「詳情頁」
    const isDetail =
      link.includes('Detail') ||
      link.includes('DetailPage') ||
      link.includes('Detail/') ||
      link.startsWith('/product/') // 商品詳情

    // 判斷是否為「列表頁」
    const isList =
      link.includes('List') ||
      link.includes('list') ||
      link.startsWith('/product-list')

    const isProductListCategory = link.startsWith('/product-list?categoryid=')
    const isProductListBrand = link.startsWith('/product-list?brandid=')
    const isMemberCenter = link.startsWith('/MemberCenter')

    let finalLink = ''

    if (isDetail) {
      // 詳情頁要加參數
      finalLink = link.endsWith('/') ? `${link}${para}` : `/${link}${para}`
    } else if (isList) {
      // 列表頁不加斜線、不加參數（除了 product-list 特例）
      if (isProductListCategory || isProductListBrand) {
        finalLink = `${link}${para}` // 保留參數
      } else {
        finalLink = link // 不加任何參數
      }
    } else if (isMemberCenter) {
      // 會員中心保持原樣
      finalLink = `${link}${para}`
    } else {
      // 其他一般頁面要加斜線，但不帶參數
      finalLink = link.startsWith('/') ? `${link}` : `/${link}`
    }

    // 防呆：移除多餘斜線
    finalLink = finalLink.replace(/\/{2,}/g, '/')

    return finalLink
  }

  const handleClickImage = () => {
    modalInstance.current?.hide()
  }

  return (
    <div
      className="modal fade"
      id="newsletterPopup"
      ref={modalElement}
      tabIndex="-1"
      data-bs-backdrop="true"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content position-relative"
          style={{ background: 'transparent', border: 'none' }}
        >
          {/* 關閉按鈕 */}
          <button
            type="button"
            className="btn-close position-absolute"
            style={{ right: '10px', top: '10px', zIndex: 10 }}
            data-bs-dismiss="modal"
            aria-label="Close"
          />

          <div className="row p-0 m-0">
            <div className="col-12 p-0">
              {/* 🟦 圖片容器（RWD） */}
              <div className={styles.newsletterImgContainer}>
                <Link href={resolveHref(newsLetter)} onClick={handleClickImage}>
                  <Image
                    src={newsLetter.ComputerPicturePath}
                    alt="newsletter"
                    fill
                    loading="lazy"
                    priority={false}
                    sizes="100vw"
                    style={{ objectFit: 'contain' }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
